import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_vm.accountInfo.tag != 0 ? _c("a-form-item", {
    attrs: {
      label: _vm.$t("保单归属")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("保单归属"),
      "show-search": "",
      "option-filter-prop": "children"
    },
    on: {
      change: _vm.getTagsFun
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1) : _vm._e(), _c("a-form-item", {
    attrs: {
      label: _vm.$t("保单号")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("保单号"),
      allowClear: ""
    },
    model: {
      value: _vm.form.policyNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "policyNo", $$v);
      },
      expression: "form.policyNo"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("审核状态")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("审核状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "pending"
    }
  }, [_vm._v(_vm._s(_vm.$t("待审核")))]), _c("a-select-option", {
    attrs: {
      value: "passed"
    }
  }, [_vm._v(_vm._s(_vm.$t("审核通过")))]), _c("a-select-option", {
    attrs: {
      value: "failure"
    }
  }, [_vm._v(_vm._s(_vm.$t("审核不通过")))])], 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("申请时间")
    }
  }, [_c("a-date-picker", {
    attrs: {
      format: _vm.getFormatDate()
    },
    on: {
      change: _vm.onDateChange
    },
    model: {
      value: _vm.form.createAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "createAt", $$v);
      },
      expression: "form.createAt"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("产品名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.insuranceName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insuranceName", $$v);
      },
      expression: "form.insuranceName"
    }
  })], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _vm.accountInfo.tag == 0 || _vm.form.customerId ? _c("a-button", {
    staticClass: "marginL15",
    attrs: {
      type: "linkSeach"
    },
    on: {
      click: _vm.tagClickFun
    }
  }, [_vm._v(_vm._s(_vm.$t("标签查询")))]) : _vm._e()], 1), _vm.tagList.length != 0 ? _c("a-row", [_c("a-form-item", {
    staticClass: "tagBox",
    attrs: {
      label: _vm.$t("已选择标签")
    }
  }, [_c("tag-list", {
    attrs: {
      tagList: _vm.tagList,
      tagData: _vm.tagData,
      format: "second"
    },
    on: {
      ok: _vm.tagListOk
    }
  })], 1)], 1) : _vm._e()], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function (text, record) {
        return [_c("click-show-tag", {
          attrs: {
            data: record.tagsData
          }
        }, [_c("span", {
          attrs: {
            slot: "icon"
          },
          slot: "icon"
        }, [_c("a-icon", {
          attrs: {
            type: "switcher"
          }
        })], 1)])];
      }
    }, {
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "statusName",
      fn: function (text, record) {
        return [_c("div", {
          style: record.status == "FAILURE" ? "color:red" : ""
        }, [_vm._v(_vm._s(text))])];
      }
    }, {
      key: "insuranceName",
      fn: function (text, record) {
        return [_vm._v(" " + _vm._s(_vm.accountInfo.tag == 0 ? record.customerInsuranceName : text) + " ")];
      }
    }, {
      key: "status",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text == "PENDING" ? _vm.$t("待审核") : text == "PASSED" ? _vm.$t("审核通过") : text == "FAILURE" ? _vm.$t("审核不通过") : "") + " ")];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_c("a-button", {
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "customerClaim",
                params: {
                  id: record.id,
                  type: 1,
                  auditFlowTypeId: record.auditFlowTypeId,
                  policyId: record.policyId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("tag-model", {
    attrs: {
      dialogVisible: _vm.tagShow,
      tagData: _vm.tagData,
      tagList: _vm.tagList,
      format: "second"
    },
    on: {
      cancel: function ($event) {
        _vm.tagShow = false;
      },
      ok: _vm.tagOk
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };